import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link, useParams, useSearchParams } from 'react-router';

import { api, unwrap } from '../api/client.js';
import { ServiceRequestForm } from '../components/ServiceRequestForm.js';
import { useLocale } from '../components/site.js';

/**
 * Service request as a page (site-help.html): the target of "Hilfe anfordern" links in the app and
 * in e-mails. About a problem it leads back to the problems, otherwise to the site.
 */
export function HelpRequest() {
  const { siteId = '' } = useParams();
  const { t } = useTranslation();
  const locale = useLocale();
  const [params] = useSearchParams();
  const findingId = params.get('finding') ?? undefined;
  const incidentId = params.get('incident') ?? undefined;
  const finding = useQuery({
    queryKey: ['finding', findingId, locale],
    queryFn: () =>
      unwrap(
        api.GET('/findings/{findingId}', {
          params: { path: { findingId: findingId ?? '' }, query: { locale } },
        }),
      ),
    enabled: Boolean(findingId),
  });
  const back = findingId ? `/sites/${siteId}/findings` : `/sites/${siteId}`;
  return (
    <>
      <div className="area-hd">
        <Link className="crumb" to={back}>
          <span aria-hidden="true">← </span>
          {findingId ? t('siteNav.findings') : t('area.back')}
        </Link>
        <h1>{t('help.title')}</h1>
        {finding.data ? (
          <div className="sub">
            <span>{t('help.forProblem')}</span> <b>{finding.data.title}</b>
          </div>
        ) : null}
      </div>
      <ServiceRequestForm
        backTo={back}
        target={{
          siteId,
          findingId: finding.isError ? undefined : findingId,
          incidentId,
          serviceCode: params.get('service') ?? undefined,
        }}
      />
    </>
  );
}
